import { Fragment, type FunctionComponent } from 'react';

import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import type { Message } from '../../../../../store/slices/chat/types';

export interface MessageContentConnectedProps extends Pick<Message, 'content' | 'requireTranslation'> {}

export const MessageContentConnected: FunctionComponent<MessageContentConnectedProps> = ({
  content,
  requireTranslation,
}) => {
  if (!requireTranslation) {
    return content;
  }

  const messageKeys = content.split(' ');

  return messageKeys.map((key, index) => {
    return (
      <Fragment key={key}>
        <L10nText tk={key} />
        {index !== messageKeys.length - 1 ? ' ' : ''}
      </Fragment>
    );
  });
};
